// extracted by mini-css-extract-plugin
module.exports = {"frame":"style_frame__1ymh4","floorList":"style_floorList__2pGgY","item":"style_item__2x2Fk","selected":"style_selected__1sTaY","arrow":"style_arrow__-FVH4"};